import { render, staticRenderFns } from "./SportProgramEditFaq.vue?vue&type=template&id=087cf43a&"
import script from "./SportProgramEditFaq.vue?vue&type=script&lang=js&"
export * from "./SportProgramEditFaq.vue?vue&type=script&lang=js&"
import style0 from "./SportProgramEditFaq.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports